import { render, staticRenderFns } from "./uploadInfo.vue?vue&type=template&id=4729121b"
import script from "./uploadInfo.vue?vue&type=script&lang=js"
export * from "./uploadInfo.vue?vue&type=script&lang=js"
import style0 from "./uploadInfo.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports